import * as React from "react"
import {useEffect} from "react"
import {useSignal} from "@preact/signals-react";
import {Grid} from "@mui/material";
import {TextFieldSeeker} from "@ui-seeker/core";


export default function RawMatcherOptionsFilters({ searchText, onInputChange }) {
	const localValue = useSignal('')

	useEffect(() => {
		localValue.value = searchText
	}, [searchText])

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<TextFieldSeeker
				label="Search"
				helperText="press enter to search"
				startIcon="search"
				value={localValue.value}
				onChange={e => localValue.value = e.target.value}
				onKeyPress={(event) => {
					if (event.key === "Enter")
						onInputChange(localValue.value)
				}}
			/>
		</Grid>
	</Grid>
}